import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import StarField from "../components/StarField";
import { setSeo, setRobots } from "../lib/api";

export default function NotFound() {
  useEffect(() => {
    setSeo(
      "404 - Page Not Found | Shillong Lucky Ending",
      "The page you are looking for does not exist. Go back to the Shillong Lucky Ending home page for today's live result."
    );
    setRobots("noindex, follow");
    return () => setRobots("index, follow");
  }, []);

  return (
    <div data-testid="not-found-page">
      <StarField />
      <Header />
      <div className="nf-wrap">
        <div className="nf-code" data-testid="nf-code">404</div>
        <h1 className="nf-title">Page Not Found</h1>
        <p className="nf-text">
          Sorry, the page you requested does not exist or may have been moved. Use the links below to continue
          exploring <strong>Shillong Lucky Ending</strong>.
        </p>
        <div className="nf-links">
          <Link className="btn-old-result" to="/" data-testid="nf-home-btn">
            Go to Home
          </Link>
          <Link className="btn-home" to="/all-result-list" data-testid="nf-results-btn">
            All Results
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
